export const LOGIN = 'login'
export const LOGOUT = 'logout'
export const PAGINATION = 'rememberPagination'
export const DELETE_HANDLER = 'deleteHandler'
export const DELETE_SINGLE_RECORD_HANDLER = 'deleteSingleRecordHandler'
export const RELOAD_NEW_CONTENT = 'reloadNewContent'
